import ChoiceElementProps, { ChoiceItem } from 'components/ChoiceElement/ChoiceElementProps';
import visitorFieldNames from 'components/Dynamics/VisitorFieldNames';
import { PropsWithEpiContent } from 'types/Props';

export interface DynamicsSubmitPayload {
    formElement: HTMLFormElement;
    formId: string;
    formApiUrl: string;
    items: PropsWithEpiContent[];
}

export function formSubmitDynamics({ formElement, formId, formApiUrl, items }: DynamicsSubmitPayload): Promise<void> {
    if (!window.d365mktformcapture) {
        return Promise.reject(new Error('d365mktformcapture not available'));
    }

    const dynamicsMappings = items
        .filter((item: PropsWithEpiContent) => item.elementName?.startsWith('__field_'))
        .map((item: PropsWithEpiContent) => {
            const isChoiceElementBlock = item.component === 'ChoiceElementBlock';
            let dataverseFieldValue;

            // Doc: Mapping of DataverseFieldValue: https://learn.microsoft.com/en-us/dynamics365/customer-insights/journeys/real-time-marketing-form-capture#21-mapping-of-optionset-fields
            if (isChoiceElementBlock) {
                const choiceItem = item as ChoiceElementProps;
                dataverseFieldValue = choiceItem.items?.map((option: ChoiceItem) => ({
                    FormValue: option.caption,
                    DataverseValue: option.value,
                }));
            }

            return {
                FormFieldName: item.elementName,
                DataverseFieldName: item.name
                    ? item.name
                          .toLowerCase()
                          .replace(/\s+/g, '_')
                          .replace(/[^a-z0-9_]/g, '')
                    : 'unnamed',
                ...(dataverseFieldValue !== undefined && {
                    DataverseFieldValue: dataverseFieldValue,
                }),
            };
        });
    // Add static mappings for known visitor fields (not part of "items")
    const visitorFieldMappings = visitorFieldNames.map((fieldName) => ({
        FormFieldName: fieldName,
        DataverseFieldName: fieldName,
    }));

    try {
        const serializedForm = window.d365mktformcapture.serializeForm(formElement, [...dynamicsMappings, ...visitorFieldMappings]);
        const payload = serializedForm.SerializedForm.build();
        const captureConfig = {
            FormId: formId,
            FormApiUrl: formApiUrl,
        };

        return window.d365mktformcapture.submitForm(captureConfig, payload);
    } catch (err) {
        return Promise.reject(err);
    }
}
